﻿import { useState } from 'react';

// components
import Error from './Error'


const Money = ({...props }) => {

    const [currentAnswer, setCurrentAnswer] = useState('')
    const [valid, setValid] = useState(true)
    const [errors, setErrors] = useState({})

    const empty = currentAnswer === ''

    const updateAnswer = (event) => {
      
        const element = event.target;
        let valid = element.validity.valid
        let message = element.validationMessage

        if (element.validity.patternMismatch) {
            element.setCustomValidity('Endast siffror är tillåtna')
            setErrors({
                ...errors,
                [event.target.name]: message
            })
        } else {
            element.setCustomValidity('')
            setCurrentAnswer(event.target.value)
            setErrors({})
        }
       setValid(valid)
    }

    return (
        <div className="pension-wizard-block__question__card__money">
            <input
                className="pension-wizard-block__question__card__money__input"
                name='money'
                type="text"
                pattern="^\d+$"
                id={props.id}
                value={currentAnswer}
                onChange={(event) => { event.persist(); updateAnswer(event) }}
                onKeyDown={(event) => event.key === 'Enter' && event.preventDefault()}
            />
            <label
                className="pension-wizard-block__question__card__money__label"
                htmlFor={props.id}>kr/mån
            </label>

            {errors &&
                <Error error={errors.radio} />
            }
            <button
                type="button"
                className={`button button--green ${empty || !valid ? "disabled" : ""}`}
                onClick={() => props.handleAnswer(currentAnswer, props.id)}
                disabled={ empty || !valid ? true : false}
            >{props.buttonText}
            </button>
        </div>
     )
}

export default Money;

